import _chunk from 'lodash/chunk';
import isDesktop from '@lib/is-desktop';

/**
 * Aligns benefits cta's by resizing the body text
 *
 * Since benefits are grouped by 3 per line we resize the text of each of them
 * only when we are on desktop otherwise we will auto them
 *
 * @param {HTMLElement} benefitsElement
 */
function alignBenefitsCallToActions(benefitsElement) {
    const benefits = benefitsElement.querySelectorAll('.benefit');
    _chunk(benefits, 3).forEach(align);

    function align(group) {
        group.forEach((el) => (getBody(el).style.height = 'auto'));

        if (isDesktop()) {
            const size = group.map((el) => getBody(el).offsetHeight).reduce((acc, elSize) => Math.max(elSize, acc), 0);
            group.forEach((el) => {
                const body = getBody(el);
                body.style.height = size + 'px';
            });
        }
    }

    function getBody(el) {
        return el.querySelector('.benefit__body');
    }
}

window.Drupal.behaviors.benefits = {
    attach: function (context) {
        const benefits = context.querySelectorAll('.benefits');
        if (!benefits.length) return;

        benefits.forEach(alignBenefitsCallToActions);
        window.addEventListener(
            'resize',
            () => {
                benefits.forEach(alignBenefitsCallToActions);
            },
            { passive: true }
        );
    },
};
